<template>
<div class="link-wrapper">
   <atom-text size="x-small" :text="question"/>
   <router-link :to="{name: routeName}">
      <atom-button
         :label="label"
         color="light"
         size="small"
         style="max-width: 320px !important; margin-left: auto !important; margin-right: auto !important;"
         fullWidth
      />
   </router-link>
</div>
</template>

<script>
import AtomText from '../../../atoms/Login/Text';
import AtomButton from '../../../atoms/Login/Button';

export default {
   name: "footer-links",
   components: {
      AtomText,
      AtomButton
   },
   props: {
      question: {
         type: String,
         required: true,
      },
      label: {
         type: String,
         required: true,
      },
      routeName: {
         type: String,
         required: true,
      }
   }
}
</script>

<style lang="scss" scoped>
.link-wrapper {
   width: 100%;
   text-align: center;

   a {
      text-decoration: none;
   }
}
</style>